module.exports = __webpack_public_path__ + "img/yamakwa.c02b13aa.jpg";